module.exports = __webpack_public_path__ + "img/positionColumns.bff204f2.jpg";